import { HeadingItem } from './HeadingItem'
import { TextItem } from './TextItem'
import { NavItem } from './NavItem'
import { MenuSubItem } from '../menuTypes'

export function MenuItem({
  row,
  rowIndex,
  setIsModalOpen,
}: {
  row: MenuSubItem
  rowIndex: number
  setIsModalOpen: (status: boolean) => void
}) {
  if (row.type === 'heading') {
    return <HeadingItem name={row.name} />
  }

  if (row.type === 'text') {
    return <TextItem name={row.name} />
  }

  return (
    <NavItem row={row} rowIndex={rowIndex} setIsModalOpen={setIsModalOpen} />
  )
}
